import { App } from 'app/components/App';
import { SocketProvider } from 'app/providers/SocketProvider';
import StoreProvider from 'app/store/providers/StoreProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppConfiguration } from 'app/components/AppConfiguration';
import { CombineProviders, ProviderModel } from 'shared/components/CombineProviders';
import { OnlineContextProvider } from 'app/providers/OnlineProvider';

ReactDOM.render(
  <CombineProviders
    providers={[
      new ProviderModel(OnlineContextProvider),
      new ProviderModel(SocketProvider),
      new ProviderModel(StoreProvider),
      new ProviderModel(AppConfiguration),
    ]}
  >
    <App />
  </CombineProviders>,
  document.getElementById('root')
);
